
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write_comment",
      function () {
        return require("private-next-pages/write_comment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/write_comment"])
      });
    }
  